import { AxiosResponse } from 'axios'
import dayjs from 'dayjs'

import { SecurityField } from 'types/securityField'
import { ApiShift, ShiftContent } from 'types/shift'

import { _axios } from './axios'

const FILTER_BY_SECURITY_FIELD = (securityFieldId: string) =>
  `/shifts/${securityFieldId}`
const AUTO_ASSIGN = (securityFieldId: string) =>
  `/shifts/auto_assign/${securityFieldId}`
const BULK_UPSERT = '/shifts/bulk_upsert'
const CSV_DOWNLOAD = (securityFieldId: string) =>
  `/shifts/csv/${securityFieldId}`

export const shiftApi = () => {
  const filterBySecurityField = async (
    securityFieldId: string,
    year: number,
    month: number,
  ): Promise<AxiosResponse<ApiShift>> => {
    const response: AxiosResponse<ApiShift> = await _axios().get(
      FILTER_BY_SECURITY_FIELD(securityFieldId),
      {
        params: {
          year,
          month,
        },
      },
    )

    // string -> date
    response.data = {
      ...response,
      securities: response.data.securities.map((security) => ({
        ...security,
        shifts: security.shifts.map((shift) => ({
          ...shift,
          date: dayjs(shift.date),
        })),
      })),

      freemen: response.data.freemen.map((security) => ({
        ...security,
        shifts: security.shifts.map((shift) => ({
          ...shift,
          date: dayjs(shift.date),
        })),
      })),
    }

    return response
  }

  const downloadCsv = async (
    securityField: SecurityField,
    year: number,
    month: number,
  ): Promise<void> => {
    const params = { year, month }

    const response = await _axios().get(CSV_DOWNLOAD(securityField.id), {
      params,
      responseType: 'blob',
    })

    const blob = new Blob([response.data], { type: 'text/csv' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute(
      'download',
      `${year}-${month}シフト_${securityField.name}.csv`,
    )
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  }

  const autoAssign = async (
    securityFieldId: string,
    year: number,
    month: number,
  ) => {
    const response: AxiosResponse<ApiShift> = await _axios().get(
      AUTO_ASSIGN(securityFieldId),
      {
        params: {
          year,
          month,
        },
      },
    )

    // string -> date
    response.data = {
      ...response,
      securities: response.data.securities.map((security) => ({
        ...security,
        shifts: security.shifts.map((shift) => ({
          ...shift,
          date: dayjs(shift.date),
        })),
      })),

      freemen: response.data.freemen.map((security) => ({
        ...security,
        shifts: security.shifts.map((shift) => ({
          ...shift,
          date: dayjs(shift.date),
        })),
      })),
    }

    return response
  }

  const bulkUpsert = async (data: {
    year: number
    month: number
    securityFieldId: string
    securityIds: string[]
    shifts: ShiftContent[]
  }) => {
    return await _axios().post(BULK_UPSERT, data)
  }

  return {
    autoAssign,
    filterBySecurityField,
    downloadCsv,
    bulkUpsert,
  }
}
